import {Placement} from '@popperjs/core';
import React, {FC, ReactNode} from 'react';

import {FrontClickEvent} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {CellsContext} from '../../../../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {IconButton} from '../../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {ConversationBaseModel} from '../../../../../../models/api/conversationModel';
import {ConversationsArchiveButtonProps} from '../../../../viewer/conversation/actions/archive/conversationsArchiveCoordinator';
import {ConversationsArchiveCoordinatorContainer} from '../../../../viewer/conversation/actions/archive/conversationsArchiveCoordinatorContainer';

/*
 * Props.
 */

export interface CellHoverArchiveProps {
  cellsContext: CellsContext;
  conversations: ReadonlyArray<ConversationBaseModel>;
  onDoubleClick: (event: FrontClickEvent) => void;
  archiveLabel: ReactNode;
  placement?: Placement;
}

/*
 * Component.
 */

export const CellHoverArchive: FC<CellHoverArchiveProps> = (props) => {
  const theme = useUserTheme();

  const renderButton = (archiveProps: ConversationsArchiveButtonProps) => {
    const {permissionResult, onClick, areAllArchived: isArchived} = archiveProps;
    const archiveStandardColor = isArchived ? theme.palette.green.shade40 : theme.greys.shade80;

    return (
      <IconButton
        iconName={isArchived ? 'archiveFilledSmall' : 'archiveSmall'}
        onClick={(event) => {
          event.preventDefault();
          onClick();
        }}
        onDoubleClick={props.onDoubleClick}
        label={props.archiveLabel}
        // This moves the tooltip label 2px higher
        labelMargin={2}
        color={archiveStandardColor}
        hoverColor={archiveStandardColor}
        backgroundHoverColor={theme.alphas.gray10}
        placement={props.placement ?? 'top'}
        size={VisualSizesEnum.SMALL}
        isDisabled={!permissionResult.isAllowed}
      />
    );
  };

  return (
    <ConversationsArchiveCoordinatorContainer
      panelId={undefined}
      cellsContext={props.cellsContext}
      conversations={props.conversations}
      isBulkActionRequired={false}
      renderButton={renderButton}
      isArchiveFromQuickActions
    />
  );
};
